/**
 * 모든 그리드 컬럼 상태(localStorage)를 초기화하는 공통 유틸
 *
 * 각 화면 그리드는 컬럼 순서/너비/표시 상태를 `{화면코드}-...-column-state`
 * 형태의 키로 localStorage에 저장한다. (예: 'PUR1021_R01-grid-column-state',
 * 'SAL6030_R01-header-column-state', 'WMS1120_R01-bom-grid-column-state' 등)
 * 접미사 'column-state'가 전 화면 공통이므로, 하드코딩 목록 대신 패턴 매칭으로
 * 신규 화면까지 누락 없이 일괄 제거한다.
 */

export const COLUMN_STATE_SUFFIX = 'column-state';

/**
 * localStorage에 저장된 모든 그리드 컬럼 상태 키를 제거한다.
 * @returns 삭제된 키 개수
 */
export const resetAllColumnStates = (): number => {
	const keys: string[] = [];

	// 삭제 중 인덱스가 밀리지 않도록 먼저 대상 키를 수집한 뒤 제거
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (
			key &&
			(
				key.endsWith(COLUMN_STATE_SUFFIX) 
			)
		) {
			keys.push(key);
		}
	}

	keys.forEach(key => localStorage.removeItem(key));

	return keys.length;
};
